module.exports = __webpack_public_path__ + "static/media/visible-icon.9b844e9d.png";